import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  locale: string;

  constructor(private router: Router, private translate: TranslateService) {
    let locale = window.location.pathname.split("/")[1];

    if (locale === "en-ca") {
      $("html").attr("lang", "en-ca");
    } else if (locale === "fr-ca") {
      $("html").attr("lang", "fr-ca");
    } else if (locale === "en-gb") {
      $("html").attr("lang", "en-gb");
    } else if (locale === "en-us") {
      $("html").attr("lang", "en-us");
    } else if (locale === "de-de") {
      $("html").attr("lang", "de-de");
    } else if (locale == "fr-fr") {
      $("html").attr("lang", "fr-fr");
    } else if (locale == "en-au") {
      $("html").attr("lang", "en-au");
    } else if (locale == "ru-ru") {
      $("html").attr("lang", "ru-ru");
    } else if (locale == "pl-pl") {
      $("html").attr("lang", "pl-pl");
    }
  }

  ngOnInit() {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.locale = e.url.split("/")[1];

        this.translate.setDefaultLang(this.locale);
        this.translate.use(this.locale);
      }
    });
  }
}
